import { OAuthFlowsElement } from '@swagger-api/apidom-ns-openapi-3-1';
/**
 * @public
 */
class OAuthFlows extends OAuthFlowsElement {
  /**
   * OpenAPI 3.2: Configuration for OAuth 2.0 device authorization flow.
   */
  get deviceAuthorization() {
    return this.get('deviceAuthorization');
  }
  set deviceAuthorization(deviceAuthorization) {
    this.set('deviceAuthorization', deviceAuthorization);
  }
}
export default OAuthFlows;